import type { BookingResponse } from '@/shared/api';
import type { SortState } from '../components/bookingsListSearch';

/**
 * Apartment und Gast sortiert die Seite selbst: der Server kann es nicht (kein JOIN). Das gilt nur
 * für die gelieferte Seite, wie bisher in der Tabelle.
 */
export function sortRowsLocally(
  rows: BookingResponse[],
  sort: SortState,
  apartmentName: (propertyId: string) => string,
): BookingResponse[] {
  if (sort.field !== 'property' && sort.field !== 'guest') return rows;
  const key = (row: BookingResponse) =>
    sort.field === 'property' ? apartmentName(row.propertyId) : (row.guestName ?? '');
  const direction = sort.direction === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => key(a).localeCompare(key(b), 'de') * direction);
}
